import cloneDeep from '@utils/cloneDeep';

export default function cleanNotAvailableOptions(optionGroups) {
  if (!optionGroups) return [];

  const newOptionsGroups = cloneDeep(optionGroups);

  return newOptionsGroups.reduce((ogList, og) => {
    if (!og.notAvailable) {
      const options = og.options?.filter(o => !o.notAvailable);
      if (options?.length > 0) ogList.push({ ...og, options });
    }
    return ogList;
  }, []);
}
